function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { clickAway } from './ClickAwayContext';
/**
 * Component Wrapper to Handle Click-Away Behavior
 *
 * ## Related Components
 * - [Dialog](../Dialog/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <ClickAway onClickAway={() => console.log('clicked away')}>
 *   <div>Click outside me calls the `onClickAway` callback on ClickAway</div>
 * </ClickAway>
 * ```
 *
 * ## Props
 */

var ClickAway = /*#__PURE__*/function (_PureComponent) {
  _inherits(ClickAway, _PureComponent);

  var _super = _createSuper(ClickAway);

  function ClickAway(props) {
    var _this;

    _classCallCheck(this, ClickAway);

    _this = _super.call(this, props);
    var node = props.node;
    _this._node = node || /*#__PURE__*/createRef();
    return _this;
  }

  _createClass(ClickAway, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._initClickAway();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._remove) {
        this._remove();
      }
    }
  }, {
    key: "_initClickAway",
    value: function _initClickAway() {
      var _this$props = this.props,
          onClickAway = _this$props.onClickAway,
          disabled = _this$props.disabled;
      if (!this._remove && (disabled || !this._node.current)) return;

      if (this._remove) {
        this._remove();
      }

      this._remove = clickAway().add({
        node: this._node.current,
        onClickAway: onClickAway
      });
    } // eslint-disable-next-line no-unused-vars

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          onClickAway = _this$props2.onClickAway,
          children = _this$props2.children,
          node = _this$props2.node,
          BaseComponent = _this$props2.as,
          rest = _objectWithoutProperties(_this$props2, ["disabled", "onClickAway", "children", "node", "as"]);

      this._initClickAway();

      if (node || disabled) return children;
      return /*#__PURE__*/React.createElement(BaseComponent, _extends({
        ref: this._node
      }, rest), children);
    }
  }]);

  return ClickAway;
}(PureComponent);

_defineProperty(ClickAway, "defaultProps", {
  as: 'div',
  onClickAway: function onClickAway() {},
  children: null,
  node: null,
  disabled: false
});

_defineProperty(ClickAway, "propTypes", {
  /**
   * Disables click away functionality passing through children for render
   */
  disabled: PropTypes.bool,

  /**
   * event callback called when the user clicks outside of the components
   * element
   */
  onClickAway: PropTypes.func,

  /**
   * any UI warranting the addition of click away behavior
   */
  children: PropTypes.node,

  /**
   * allows passing in a forwarded ref to avoid having  an unnecessary wrapping div
   */
  node: PropTypes.shape({
    current: PropTypes.any
  }),
  as: PropTypes.elementType
});

export { ClickAway as default };